import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_3 = { class: "card mb-5 mb-xl-8" }
const _hoisted_4 = { class: "card-body pt-15" }
const _hoisted_5 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_6 = {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bold mb-1"
}
const _hoisted_7 = { class: "d-flex flex-stack fs-4 py-3" }
const _hoisted_8 = {
  class: "fw-bold rotate collapsible",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_9 = { class: "ms-2 rotate-180" }
const _hoisted_10 = { class: "svg-icon svg-icon-3" }
const _hoisted_11 = {
  id: "kt_customer_view_details",
  class: "collapse show"
}
const _hoisted_12 = { class: "py-5 fs-6" }
const _hoisted_13 = { class: "text-gray-600" }
const _hoisted_14 = { class: "text-gray-600" }
const _hoisted_15 = {
  href: "#",
  class: "text-gray-600 text-hover-primary"
}
const _hoisted_16 = { class: "text-gray-600" }
const _hoisted_17 = { class: "text-gray-600" }
const _hoisted_18 = { class: "text-gray-600" }
const _hoisted_19 = { class: "text-gray-600" }
const _hoisted_20 = { class: "text-gray-600" }
const _hoisted_21 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_22 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_23 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_24 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_25 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold" }
const _hoisted_26 = { class: "nav-item pb-4" }
const _hoisted_27 = { class: "nav-item ms-auto" }
const _hoisted_28 = {
  href: "#",
  class: "btn btn-primary ps-7",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_29 = { class: "svg-icon svg-icon-2 me-0" }
const _hoisted_30 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semobold py-4 w-250px fs-6",
  "data-kt-menu": "true"
}
const _hoisted_31 = { class: "menu-item px-5" }
const _hoisted_32 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_33 = {
  class: "tab-pane fade show active",
  id: "kt_customer_view_overview_tab",
  role: "tabpanel"
}
const _hoisted_34 = {
  class: "modal fade",
  ref: "newCardModalRef",
  id: "vendor-edit",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = {
  id: "closeVendorEditModal",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_39 = { class: "svg-icon svg-icon-1" }
const _hoisted_40 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_41 = { class: "d-flex flex-column mb-7" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-12 mb-4" }
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "col-6 mb-4" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "col-6 mb-4" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "col-6 mb-4" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "col-6 mb-4" }
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "col-6 mb-4" }
const _hoisted_54 = { class: "mb-10" }
const _hoisted_55 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_56 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_57 = ["for"]
const _hoisted_58 = { class: "text-center pt-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_InvoicesTable = _resolveComponent("InvoicesTable")!
  const _component_Address = _resolveComponent("Address")!
  const _component_QpRules = _resolveComponent("QpRules")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.vendor.Name), 1),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "fs-5 fw-semobold text-muted mb-6" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[10] || (_cache[10] = _createTextVNode(" Details ", -1)),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr072.svg" })
                  ])
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("span", {
                "data-bs-toggle": "tooltip",
                "data-bs-trigger": "hover",
                title: "Edit vendor details"
              }, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-flex btn-light-primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#vendor-edit"
                }, " Edit ")
              ], -1))
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Contact Name", -1)),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.vendor.ContactName), 1),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Email", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.vendor.Email), 1)
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Phone", -1)),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.vendor.Phone), 1),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Registration Number", -1)),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.vendor.RegistrationNumber), 1),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Tax Numbe", -1)),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.vendor.TaxNumber), 1),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Status", -1)),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.vendor.Status), 1),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "fw-bold mt-5" }, "External Modify Date", -1)),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.formatExtDate(_ctx.vendor.ExternalModifyDate)), 1),
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "fw-bold mt-5" }, "Send offer automatically", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.vendor.EnableAutomaticSending)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Yes ", -1),
                        _createElementVNode("i", { class: "bi bi-check-lg ms-2 fw-semobold c" }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("No ", -1),
                        _createElementVNode("i", { class: "bi bi-x-lg ms-2" }, null, -1)
                      ]))]))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("ul", _hoisted_25, [
          _createElementVNode("li", _hoisted_26, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link text-active-primary", { active: _ctx.activeTab === 'invoices' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab('invoices'))),
              "data-bs-toggle": "tab",
              href: "#kt_customer_view_overview_tab"
            }, "Invoices", 2)
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("li", { class: "nav-item pb-4" }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary",
              "data-bs-toggle": "tab",
              href: "#address"
            }, "Address")
          ], -1)),
          _cache[26] || (_cache[26] = _createElementVNode("li", { class: "nav-item pb-4" }, [
            _createElementVNode("a", {
              class: "nav-link text-active-primary",
              "data-bs-toggle": "tab",
              href: "#qp-rules"
            }, "QP Rules")
          ], -1)),
          _createElementVNode("li", _hoisted_27, [
            _createElementVNode("a", _hoisted_28, [
              _cache[23] || (_cache[23] = _createTextVNode(" Actions ", -1)),
              _createElementVNode("span", _hoisted_29, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr072.svg" })
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "menu-item px-5" }, [
                _createElementVNode("div", { class: "menu-content text-muted pb-2 px-5 fs-7 text-uppercase" }, " Credentials ")
              ], -1)),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendVendorCredentials && _ctx.sendVendorCredentials(...args))),
                  href: "#",
                  class: "menu-link px-5"
                }, "Send Credentials")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (_ctx.isMounted)
              ? (_openBlock(), _createBlock(_component_InvoicesTable, {
                  key: _ctx.id,
                  "vendor-id": _ctx.id,
                  "card-classes": "mb-6 mb-xl-9"
                }, null, 8, ["vendor-id"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_Address),
          _createVNode(_component_QpRules)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _cache[27] || (_cache[27] = _createElementVNode("h2", null, "Vendor Details Edit", -1)),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Name"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Name"
                    })
                  ], -1)),
                  _createElementVNode("input", {
                    value: _ctx.vendor?.Name,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.vendor.Name = $event.target.value)),
                    class: "form-control form-control-solid"
                  }, null, 40, _hoisted_44)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Contact Name"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Contact name"
                    })
                  ], -1)),
                  _createElementVNode("input", {
                    value: _ctx.vendor?.ContactName,
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vendor.ContactName = $event.target.value)),
                    class: "form-control form-control-solid"
                  }, null, 40, _hoisted_46)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Registration Number"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Registration Number"
                    })
                  ], -1)),
                  _createElementVNode("input", {
                    value: _ctx.vendor?.RegistrationNumber,
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.vendor.RegistrationNumber = $event.target.value)),
                    class: "form-control form-control-solid"
                  }, null, 40, _hoisted_48)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Email"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Email"
                    })
                  ], -1)),
                  _createElementVNode("input", {
                    value: _ctx.vendor?.Email,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.vendor.Email = $event.target.value)),
                    class: "form-control form-control-solid"
                  }, null, 40, _hoisted_50)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Phone"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Phone"
                    })
                  ], -1)),
                  _createElementVNode("input", {
                    value: _ctx.vendor?.Phone,
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.vendor.Phone = $event.target.value)),
                    class: "form-control form-control-solid"
                  }, null, 40, _hoisted_52)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semobold form-label mb-2" }, [
                    _createElementVNode("span", { class: "required" }, "Enable Send offer automatically"),
                    _createElementVNode("i", {
                      class: "fas fa-exclamation-circle ms-2 fs-7",
                      "data-bs-toggle": "tooltip",
                      title: "Enable Send offer automatically"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: "flexSwitchCheckedEdit",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.vendor.EnableAutomaticSending) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.vendor.EnableAutomaticSending]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: _ctx.flexSwitchCheckedEdit
                        }, _toDisplayString(_ctx.vendor.EnableAutomaticSending ? 'Enabled' : 'Disabled'), 9, _hoisted_57)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submitVendorDetailsEdit && _ctx.submitVendorDetailsEdit(...args))),
                type: "button",
                class: "btn btn-primary"
              }, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("span", { class: "indicator-label" }, " Save ", -1),
                _createElementVNode("span", { class: "indicator-progress" }, [
                  _createTextVNode(" Please wait... "),
                  _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
                ], -1)
              ]))])
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}